<!--
    Created by 杨莎莎 on 2025/08/11.
    Copyright © 2024年 云柜-金星晖. All rights reserved.
    功能概述：商户管理-新增/编辑商户
-->
<style lang="less">
.agent-merchant-submit {
  .ivu-radio-group {
    width: 100%;
  }
  .form-item-bottom-tips {
    font-size: 12px;
    color: @textColorLight;
    line-height: 25px;
  }
}
</style>

<template>
  <yg-drawer
    width="680"
    :back-type="2"
    :title="(model.id ? '编辑' : '新增') + '商户'"
    :sure-button-disabled="buttonDisabled"
    :sure-button-disabled-text="buttonDisabledMsg"
    @on-close="onClose"
    @on-sure="onSure"
  >
    <div
      slot="content"
      class="agent-merchant-submit"
    >
      <yg-card
        v-for="(item, index) in formList"
        :key="index"
        :title="item.title"
        class="margin-primary-bottom"
      >
        <div slot="content">
          <Form>
            <FormItem
              v-for="(res, ind) in item.formItems"
              :key="ind"
              :label="res.label + ':'"
              :label-width="120"
              :required="res.isRequired"
            >
              <Input
                v-if="res.tagName === 'Input'"
                v-model.trim="model[res.key]"
                :placeholder="res.placeholder"
                :disabled="res.isDisabled"
                :maxlength="res.maxLength"
                @input="checkSubmit"
              />
              <yg-global-select
                v-else-if="res.tagName === 'YgGlobalSelect'"
                v-model="model[res.key]"
                :select-type="res.selectType"
                :disabled="res.isDisabled"
                @on-change="checkSubmit"
              />
              <RadioGroup
                v-else-if="res.tagName === 'Radio'"
                v-model="model[res.key]"
                @on-change="onChangeRadio"
              >
                <Radio
                  v-for="(sub, j) in res.dataOptions"
                  :key="j"
                  :label="sub.value"
                  :disabled="res.isDisabled"
                >
                  {{ sub.label }}
                </Radio>
              </RadioGroup>
              <Select
                v-else-if="res.tagName === 'Select'"
                v-model="model[res.key]"
                :placeholder="res.placeholder"
                :disabled="res.isDisabled"
                @on-change="checkSubmit"
              >
                <Option
                  v-for="(sub, j) in res.dataOptions"
                  :key="'op-' + j"
                  :value="sub.value"
                >
                  {{ sub.label }}
                </Option>
              </Select>
              <div
                v-if="res.tips"
                class="form-item-bottom-tips"
              >
                说明: {{ res.tips }}
              </div>
            </FormItem>
          </Form>
        </div>
      </yg-card>
    </div>
  </yg-drawer>
</template>

<script>
export default {
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      buttonDisabled: true,
      buttonDisabledMsg: '数据无变化'
    };
  },
  computed: {
    isNeedRequired () {
      return this.model.merchantType === 2;
    },
    isNeedDisabled () {
      // 编辑
      if (this.model.merchantCode) {
        if (this.model.merchantStatus === 2 || this.model.merchantStatus === 3) {
          return true;
        }
      }
      // 新增
      return false;
    },
    formList () {
      return [
        {
          title: '基础信息',
          formItems: [
            // { label: '业态体系', key: 'businessType', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'YgGlobalSelect', selectType: 'businessType', placeholder: '请选择业态体系' },
            // { label: '所属办事处', key: 'officeCode', isRequired: true, isDisabled: this.model.merchantStatus === 2, tagName: 'YgGlobalSelect', selectType: 'officeList', placeholder: '请选择所属办事处' }
            { label: '所属办事处', key: 'officeCode', isRequired: false, isDisabled: true, tagName: 'Select', dataOptions: [{ label: '全国', value: 0 }] }// 设置成默认全国，不选择
          ]
        },
        {
          title: '开户信息',
          formItems: [
            { label: '商户类型', key: 'merchantType', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Radio', placeholder: '请选择商户类型', tips: '个人时，只支持绑定个人银行卡；企业时，只支持绑定对公账户', dataOptions: [{ label: '个人', value: 1 }, { label: '企业', value: 2 }] },
            { label: '证件类型', key: 'idCardType', isRequired: false, isDisabled: true, tagName: 'Select', placeholder: '选择商户类型后自动带入', dataOptions: [{ label: '身份证', value: 1 }, { label: '社会信用代码', value: 2 }] },
            { label: '证件号码', key: 'idCard', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输入证件号码' },
            { label: '商户名称', key: 'merchantCompany', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输入商户名称' },
            { label: '手机号码', key: 'merchantTel', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', maxLength: 11, placeholder: '请输入手机号码', canHidePhone: true, tips: '该手机号为登录“云柜管家助手”小程序，查看收入及提现的帐号' }
          ]
        },
        {
          title: '银行信息',
          formItems: [
            { label: '开户银行名称', key: 'bankName', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输入开户银行' },
            { label: '开户支行名称', key: 'branchBank', isRequired: this.isNeedRequired, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输入开户支行' },
            { label: '开户行行号', key: 'interBankNo', isRequired: this.isNeedRequired, isDisabled: this.isNeedDisabled, tagName: 'Input', maxLength: 12, placeholder: '请输入开户行行号' },
            { label: '银行账号', key: 'bankNo', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', maxLength: 40, placeholder: '请输入银行账号' }
          ]
        },
        {
          title: '冻结金额设置',
          formItems: [
            // { label: '冻结金额(元)', key: 'preFrozenAmount', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输入冻结金额', tips: '商户余额里冻结该金额不可提现，填写0表示资金不冻结' }
            { label: '冻结金额(元)', key: 'freezeAmount', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输入冻结金额', tips: '商户余额里冻结该金额不可提现，填写0表示资金不冻结' },
            { label: '预警金额(元)', key: 'warningAmount', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', placeholder: '请输预警金额', tips: '' },
            { label: '预警手机号码', key: 'earlyWarningTels', isRequired: true, isDisabled: this.isNeedDisabled, tagName: 'Input', maxLength: 11, placeholder: '请输入手机号码', canHidePhone: true }
          ]
        }
      ];
    }
  },
  created () {
    this.model.officeCode = 0;

    this.$nextTick(() => {
      this.checkSubmit();
    });
  },
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    // 表单校验
    checkSubmit () {
      // 重置按钮状态
      this.buttonDisabled = false;
      this.buttonDisabledMsg = '';

      for (const data of this.formList) {
        for (const item of data.formItems) {
          if (!item.isRequired) continue;

          if (!this.model[item.key]) {
            this.buttonDisabled = true;
            this.buttonDisabledMsg = `${item.label}不能为空`;
            return;
          }
        }
      }
    },
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    // 商户类型变更时
    onChangeRadio (value) {
      this.model.merchantType = value;
      this.model.idCardType = value;
      this.checkSubmit();
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    onClose () {
      this.$emit('on-close', false);
    },
    onSure () {
      const res = this.model.checkSubmitValid();
      if (!res.success) {
        return this.$Message.warning(res.msg);
      }
      this.$emit('on-sure', res.params);
    }
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
